module.exports = __webpack_public_path__ + "img/roomie.7e021b09.png";